export default __webpack_public_path__ + "static/media/triangle-pattern_cri-100.1f6f5d68.jpg";